export default __webpack_public_path__ + "static/media/Ballroll_00314.275aaefa.png";